import { useCallback } from 'react';
import { api } from '../api/client';
import {
    CandidateComparisonRequest,
    CandidateComparisonResponse,
    CandidateComparisonReviewOption,
} from '../types/candidateComparison';

export const useCandidateComparisonService = () => {
    const getReviewOptions = useCallback(async (jobPostingId: string): Promise<CandidateComparisonReviewOption[]> => {
        const response = await api.get('/api/CandidateComparison/Reviews', {
            params: { jobPostingId },
        });
        return Array.isArray(response.data) ? response.data : [];
    }, []);

    const compareCandidates = useCallback(async (
        request: CandidateComparisonRequest,
    ): Promise<CandidateComparisonResponse> => {
        const response = await api.post('/api/CandidateComparison/Analyze', request);
        return response.data;
    }, []);

    return { getReviewOptions, compareCandidates };
};
